import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30095fa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plaque-card__wrapper" }
const _hoisted_2 = { class: "plaque-card__header" }
const _hoisted_3 = { class: "plaque-card__date" }
const _hoisted_4 = { class: "plaque-card__number" }

import { PropType, computed } from 'vue'
import { ReportType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  report: Object as PropType<ReportType>,
  active: Boolean as PropType<boolean>,
},
  setup(__props) {

const props = __props



const getArrowDirection = computed(() => {
  if (props.report.status === 'success') {
    return '↓'
  }

  if (props.report.status === 'error') {
    return '↑'
  }

  return ''
})

const getStatusClasses = computed(() => {
  if (props.report.status === 'success') {
    return 'plaque-card__percent--success'
  }

  if (props.report.status === 'error') {
    return 'plaque-card__percent--error'
  }

  return ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'plaque-card',
      {
        'plaque-card--active': __props.active,
      },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.report.date_at), 1),
        _createElementVNode("p", {
          class: _normalizeClass(["plaque-card__percent", _unref(getStatusClasses)])
        }, _toDisplayString(_unref(getArrowDirection)) + " " + _toDisplayString(__props.report.percentage) + "% ", 3)
      ]),
      _createElementVNode("p", _hoisted_4, "№" + _toDisplayString(__props.report.id), 1)
    ])
  ], 2))
}
}

})